export default __webpack_public_path__ + "static/media/contributors.b0436643.svg";